import { NgaModule } from '../../../theme/nga.module';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'login-dialog',
  styleUrls: ['./logindialog.component.css'],
  template: ` <login (signedIn)="loginResult($event)" toUrl="test"></login> `,
})
export class LoginDialog {
  constructor(public dialogref: MatDialogRef<LoginDialog>) {}

  public loginResult(res: any) {
    console.log({ logindialogresult: res });
    this.dialogref.close(res);
  }
}
